import { ButtonProps as AntButtonProps } from 'antd'

export type ButtonProps = AntButtonProps

export { Button } from 'antd'
